module.exports = __webpack_public_path__ + "static/img/powerpoint.7fed6df5.svg";